import axios from './index';

// 简历引导-next
export const submitResumeIntention = (data) => {
  return axios.post('/api/resume/updateIntention', data);
};

// 上传简历
export const uploadResume = (data) => {
  return axios.post('/api/resume/uploadResumeV2', data);
};

// 查询当前简历信息
export const fetchResumeInfo = () => {
  return axios.get('/api/resume/getCurrentUserResume');
};

// 新增简历
export const addResume = (data) => {
  return axios.post('/api/resume/add', data);
};

// 修改简历
export const updateResume = (data) => {
  return axios.post('/api/resume/update', data);
};

// 修改简历 核心内容
export const updateResumeMajor = (data) => {
  return axios.post('/api/resume/updateMajorComponents', data);
};

// 查询简历对应的标签
export const fetchJobSkill = () => {
  return axios.get('/api/resumeJobSkill/getCurrentUserSkills');
};

// 修改简历对应的标签
export const updateJobSkill = (data) => {
  return axios.post('/api/resumeJobSkill/batchUpdate', data);
};

// 查询简历视频
export const fetchResumeVideo = () => {
  return axios.get('/api/resumeVideo/getCurrentUserVideos');
};

// 修改简历视频
export const updateResumeVideo = (data) => {
  return axios.post('/api/resumeVideo/batchUpdate', data);
};

// 修改个人优势
export const updateResumeAdvantage = (data) => {
  return axios.post('/api/resume/advantage', data);
};

// 查询工作经验
export const fetchWorkExperience = () => {
  return axios.get('/api/resumeExperience/getCurrentUserExperiences');
};

// 新增工作经验
export const addWorkExperience = (data) => {
  return axios.post('/api/resumeExperience/add', data);
};

// 更新工作经验
export const updateWorkExperience = (data) => {
  return axios.post('/api/resumeExperience/update', data);
};

// 删除工作经验
export const deleteWorkExperience = (data) => {
  return axios.post('/api/resumeExperience/delete', data);
};

// school 下拉列表
export const schoolSearch = (data) => {
  return axios.post('/api/offlineEducation/queryPage', data);
};

// 查询教育经验
export const fetchResumeEducation = () => {
  return axios.get('/api/resumeEducation/getCurrentUserEducations');
};

// 新增教育经验
export const addResumeEducation = (data) => {
  return axios.post('/api/resumeEducation/add', data);
};

// 更新教育经验
export const updateResumeEducation = (data) => {
  return axios.post('/api/resumeEducation/update', data);
};

// 删除教育经验
export const deleteResumeEducation = (data) => {
  return axios.post('/api/resumeEducation/delete', data);
};

// 修改个人优势
export const updateResumeInfluence = (data) => {
  return axios.post('/api/resume/influence', data);
};

// 修改个人优势
export const updateResumeCurrentTask = (data) => {
  return axios.post('/api/resume/currentTask', data);
};

// 查询评价提交
export const fetchResumeEvaluation = () => {
  return axios.get('/api/evaluation/current');
};

// 查询进行中的评价
export const fetchResumeActiveEvaluation = () => {
  return axios.get('/api/evaluation/invitation/records');
};

// 删除进行中的评价
export const deleteResumeActiveEvaluation = (id) => {
  return axios.post('/api/evaluation/invitation/cancel/' + id);
};

// 发送邀请评价
export const sendResumeEvaluation = (data) => {
  return axios.post('/api/evaluation/generateToken', data);
};

// 邀请评价提交
export const submitEvaluationWithToken = (data) => {
  return axios.post('/api/evaluation/addWithToken', data);
};

// 邀请评价 验证token
export const validEvaluationWithToken = (token) => {
  return axios.get('/api/evaluation/invitation/token/valid/' + token);
};

// 修改邀请评价
export const updateResumeEvaluation = (data) => {
  return axios.post('/api/evaluation/batchUpdate', data);
};

// 复制邀请评价链接
export const generateEvaluationToken = (data) => {
  return axios.post('/api/evaluation/generateSimpleToken', data);
};

// 发送帮助邮件
export const sendResumeHelp = (data) => {
  return axios.post('/api/resume/help/generateToken', data);
};

// 复制帮助链接
export const generateHelpToken = (data) => {
  return axios.post('/api/resume/help/generateSimpleToken', data);
};

// 岗位特质
export const getJobCategoryTraitsByName = (data) => {
  return axios.post('/api/resume/getJobCategoryTraitsByName', data);
};

// ai-润色
export const submitAiPolish = (data) => {
  return axios.post('/api/resume/stream/aiPolish', data);
};

// ai-润色-stream
export const submitAiStreamPolish = (data) => {
  return axios.post('/api/resume/aiPolish', data);
};

// 查看简历的手机号
export const fetchResumeMobile = (data) => {
  return axios.post('/api/company/mobile', data);
};

// 查看简历的邮箱
export const fetchResumeEmail = (data) => {
  return axios.post('/api/company/email', data);
};

// 查询证书
export const fetchResumeCertificate = () => {
  return axios.get('/api/resumeCertificate/getCurrentUserCertificate');
};

// 提交证书
export const submitResumeCertificate = (data) => {
  return axios.post('/api/resumeCertificate/update', data);
};
